// i18n bootstrap. Подключается один раз в index.tsx (import './i18n').
//
// Цели (issue #18):
//   - два языка: ru (по умолчанию) и en, легко расширяемо новыми файлами локалей;
//   - автоопределение языка: префикс URL (/en/...) → localStorage → язык браузера → ru;
//   - плюрализация по правилам языка (1 яблоко / 2 яблока / 5 яблок) — нативно через
//     Intl.PluralRules (i18next v21+), ICU не требуется;
//   - интерполяция значений в сложные предложения ({{count}}, {{name}} и т.п.).
//
// Локали лежат в отдельных файлах src/i18n/locales/<lng>/<namespace>.json — чтобы
// добавить язык, достаточно положить новую папку и добавить код в SUPPORTED_LANGUAGES.
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import ruCommon from './locales/ru/common.json'
import enCommon from './locales/en/common.json'
import ruPages from './locales/ru/pages.json'
import enPages from './locales/en/pages.json'
import ruFindings from './locales/ru/findings.json'
import enFindings from './locales/en/findings.json'
import ruScope from './locales/ru/scope.json'
import enScope from './locales/en/scope.json'
import ruAdmin from './locales/ru/admin.json'
import enAdmin from './locales/en/admin.json'
import ruTable from './locales/ru/table.json'
import enTable from './locales/en/table.json'
import ruReport from './locales/ru/report.json'
import enReport from './locales/en/report.json'

export const DEFAULT_LANGUAGE = 'ru'

// Поддерживаемые языки. Добавление нового: положить locales/<code>/*.json,
// импортировать и дописать сюда {code, label}.
export const SUPPORTED_LANGUAGES: { code: string; label: string }[] = [
  { code: 'ru', label: 'Русский' },
  { code: 'en', label: 'English' },
]

export const SUPPORTED_CODES = SUPPORTED_LANGUAGES.map((l) => l.code)

const resources = {
  ru: { common: ruCommon, pages: ruPages, findings: ruFindings, scope: ruScope, admin: ruAdmin, table: ruTable, report: ruReport },
  en: { common: enCommon, pages: enPages, findings: enFindings, scope: enScope, admin: enAdmin, table: enTable, report: enReport },
} as const

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_CODES,
    // Только базовый код языка (ru, en), без региональных (ru-RU → ru).
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    defaultNS: 'common',
    ns: ['common', 'pages', 'findings', 'scope', 'admin', 'table', 'report'],
    interpolation: {
      escapeValue: false, // React сам экранирует
    },
    detection: {
      // Префикс пути (/en/...) имеет приоритет — единый источник истины для locale в URL.
      // Для ru-путей (без префикса) path-детектор вернёт не-язык → отбрасывается
      // (nonExplicitSupportedLngs) → следующий детектор → localStorage/браузер → ru.
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  })

export default i18n
